module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-c1644238.png";